import {
    AccountCircle,
    BrandingWatermark,
    CategoryOutlined,
    DarkMode,
    DirectionsCarOutlined,
    EmojiPeople,
    LightMode,
    LocalShippingOutlined,
    LoyaltyOutlined,
    Redeem,
    Store
} from "@mui/icons-material";
import { type SxProps, type Theme } from "@mui/material";
import type { OfferVariant, Order } from "../models";
import type { LocationType, ValuesOf } from "../models/enums";
import { statusColorMap } from "../resources/order/icons";
import { EnumIcon, ImageIcon, type DomainImageProps } from "./fields/image-icon";

export const UserIcon = (props: DomainImageProps): JSX.Element => (
    <ImageIcon {...props} Fallback={AccountCircle} color="primary" />
);

export const CategoryIcon = ({ image, ...rest }: DomainImageProps): JSX.Element => (
    <ImageIcon
        image={image}
        Fallback={CategoryOutlined}
        variant="rounded"
        color="primary"
        {...rest}
    />
);

export const BrandIcon = ({ image, ...rest }: DomainImageProps): JSX.Element => (
    <ImageIcon
        image={image}
        Fallback={BrandingWatermark}
        variant="rounded"
        color="primary"
        {...rest}
    />
);

export const ProductIcon = ({
    image,
    type,
    ...rest
}: DomainImageProps & {
    type: "Product" | "Service" | undefined;
}): JSX.Element => (
    <ImageIcon
        image={image}
        Fallback={type === "Product" ? Redeem : EmojiPeople}
        variant="rounded"
        color="primary"
        {...rest}
    />
);

export const LocationIcon = ({
    type,
    ...rest
}: { type: ValuesOf<typeof LocationType>; sx?: SxProps<Theme> }): JSX.Element => (
    <EnumIcon icon={type === "Address" ? Store : DirectionsCarOutlined} {...rest} color="primary" />
);

export const ZoneIcon = (): JSX.Element => <EnumIcon icon={LocalShippingOutlined} color="primary" />;

export const CouponIcon = (): JSX.Element => <EnumIcon icon={LoyaltyOutlined} color="primary" />;

export const OfferVariantIcon = ({ details, offerId, name }: OfferVariant): JSX.Element => {
    const images = details
        .filter(x => x.image)
        .map(x => ({ src: x.image, title: name }));
    return (
        offerId !== 0 ? <ProductIcon
            image={images[0]}
            count={details.length > 0 ? details.length - 1 : 0}
            type="Product"
        /> : <ZoneIcon />
    );
};

export const OrderIcon = (props: Order): JSX.Element => {
    const items = props.details.filter(x => x.itemId !== 0);
    const details = items.flatMap(x => x.details);
    const images = details
        .filter(x => x.image)
        .map(x => ({ src: x.image, title: x.name }));
    return (
        <ProductIcon
            image={images[0]}
            count={items.length > 0 ? items.length - 1 : 0}
            type={"Product"}
        />
    );
};

export const ActiveIcon = ({ active }: { active: boolean }): JSX.Element => (
    <EnumIcon icon={active ? LightMode : DarkMode} color={statusColorMap.get(active ? "Complete" : "Canceled")} />
);
